// Mock data for Flying Fleet Dispatch LLC
// Edit the LOADS array to update the live load board. No other code changes needed.

export const LOADS = [
  {
    origin: "36919 (AL)", destination: "28103 (NC)", equipment: "Step Deck",
    miles: 619, pickup: "ASAP", rate: "$2,000",
    details: {
      commodity: "2 x 40ft shipping containers",
      weight: "16,000 lbs",
      delivery: "ASAP",
      note: "Step decks needed. $2,000 per truck.",
      dispatchFee: "10-12% dispatch fee",
    }
  },
  {
    origin: "Acton, ON", destination: "Bethesda, OH", equipment: "Step Deck",
    miles: 305, pickup: "ASAP", rate: "$3,500",
    details: {
      commodity: "CAT 990 Cab & Tires",
      weight: "43,000 lbs",
      trailer: "Step Deck (Over-Dimension)",
      pay: "$3,500 USD",
      requirements: [
        "Minimum $250,000 cargo insurance",
        "Oversize capable",
        "No escort vehicles required",
        "Ready for pickup",
      ],
    }
  },
  {
    origin: "Orting, WA", destination: "Huntingdon, BC", equipment: "Dry Van",
    miles: 148, pickup: "Aug 21", rate: "$375",
    details: {
      commodity: "Empty repositioning move",
      note: "48 ft empty dry van, just over the border at Huntingdon, BC.",
    }
  }
];

export const SERVICES = [
  {
    title: "24/7 Dispatching",
    desc: "Round-the-clock support finding, booking, and tracking your loads — rate negotiation and paperwork included.",
    icon: "truck",
    fee: "9% – 12% dispatch fee"
  },
  {
    title: "Carrier Sourcing",
    desc: "We match vetted, qualified carriers to freight fast, so lanes stay covered and capacity never sits idle.",
    icon: "users",
    fee: "12% – 20% fee"
  },
  {
    title: "Freight Forwarding",
    desc: "Full truckload and LTL freight forwarding coordinated coast to coast, with visibility from pickup to delivery.",
    icon: "warehouse"
  },
  {
    title: "Exclusive Broker Loads",
    desc: "Direct access to broker-only freight and preferred lanes you won't find sitting on the public load boards.",
    icon: "star"
  },
  {
    title: "Semi & Box Truck Rentals",
    desc: "Need equipment to take on more freight? We help connect you with semi and box truck rental options.",
    icon: "truckBox"
  },
  {
    title: "Load Board Access",
    desc: "A real-time board of available freight, updated daily, so you always know what's out there for your lane.",
    icon: "list"
  },
  {
    title: "Load Posting Service",
    desc: "Too busy to post your own freight? Contract us to list and manage your loads across the boards so they get seen and covered fast.",
    icon: "upload",
    fee: "Contract-based"
  },
  {
    title: "MC Owner Locator",
    desc: "Need to find the authority behind an MC number? We help drivers and carriers locate and verify MC owners quickly and reliably.",
    icon: "search"
  },
  {
    title: "Flyers & Website Design",
    desc: "Beyond dispatch — we help trucking businesses stand out with custom flyers and professional websites that win more freight.",
    icon: "palette",
    consult: true
  }
];

export const CONTACT = {
  phone: "815-406-9774",
  phoneRaw: "8154069774",
  email: "flyingfleetdispatch@yahoo.com",
  availability: "24/7 Dispatch Service"
};
